import easydropdown from 'easydropdown'
import '../../../node_modules/easydropdown/'


export default class TestModule {
  
  constructor(el) {
    function handleSelector(val) {
      el.targets.forEach(target => {
        if (target.classList.contains('active')) {
          var cache = target.innerHTML;
          target.innerHTML = '';
          target.innerHTML = cache;
          target.classList.remove('active');
          
        }
      })
      
      var targetEl = el.querySelector('[data-stream-target="' + val + '"');
      if (targetEl) {
        
        if (targetEl.getAttribute('data-type') == 'link') {
          window.open(targetEl.getAttribute('data-url', '_blank'));
          el.classList.remove('active')
          
        } else if (targetEl.getAttribute('data-type') == 'iframe') {
          el.classList.add('active')
          targetEl.classList.add('active')
          el.edd.value = val;
        }
      }
      else {
        el.classList.remove('active')
      }
    }
    
    
    function closeIframe() {
      el.classList.remove('active');
      el.targets.forEach(target => {
        if (target.classList.contains('active')) {
          var cache = target.innerHTML;
          target.innerHTML = '';
          target.innerHTML = cache;
          target.classList.remove('active');

        }
      })
    }
    
    el.header = el.querySelector('.stream-select__header');
    el.closer = el.querySelector('.fa-times');
    el.closer.addEventListener('click', closeIframe);
    
    
    
    el.targets = el.querySelectorAll('[data-stream-target]');
    el.targetWrap = el.querySelector('.stream-targets');
    
    window.addEventListener('load', function() {
      
      if (el.querySelector('[data-stream-target="multitracks"]')) {
        handleSelector('multitracks')
      }
      else if (el.querySelector('[data-stream-target="spotify"]')) {
        handleSelector('spotify')
      }
      else if (el.querySelector('[data-stream-target="apple"]')) {
        handleSelector('apple')
      }
    })
    el.selectChild = el.querySelector('select');
    el.edd = new easydropdown(el.selectChild, {
      callbacks: {
        onSelect: value=> handleSelector(value)
      }
    });
    // window.addEventListener('load', function() {
    //   setTimeout(() => {
    //     handleSelector('spotify')
    //   }, 1000);
    // })
    
  }
}